import '/src/scss/style.scss';

if (import.meta.hot) {
	import.meta.hot.accept();
}


const headerNavToggle = document.querySelector('[data-search-toggle]');
const headerNavSearch = document.querySelector('[data-search-form]')
const headerNavSearchInput = document.querySelector('input[name="q"]')

function onSearchToggleClick({target}) {
console.log(typeof target.getAttribute('aria-expanded'));

if (target.getAttribute('aria-expanded') === 'true')  {
	target.setAttribute('aria-expanded', 'false');
	} else {
		target.setAttribute('aria-expanded', 'true');
		headerNavSearchInput.focus();
	}
}

headerNavToggle.addEventListener('click', onSearchToggleClick)





let vh = window.innerHeight * 0.01;

function setVertHeight() {
	vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setVertHeight();


window.addEventListener('resize', setVertHeight);